<details #dd class="dropdown dropdown-end" (toggle)="onToggle()">
  <summary
    class="list-none btn btn-ghost btn-circle btn-sm text-primary relative [&::-webkit-details-marker]:hidden"
    title="Notifications"
    aria-label="Notifications"
  >
    <fa-icon [icon]="'bell'" class="text-base"></fa-icon>
    @if (badgeLabel()) {
      <span
        class="absolute -top-0.5 -right-0.5 min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-error text-error-content text-[10px] font-bold leading-[1.1rem] text-center"
      >
        {{ badgeLabel() }}
      </span>
    }
  </summary>

  <div
    class="dropdown-content bg-base-100 rounded-box shadow-lg w-80 z-50 mt-2 border border-base-300 overflow-hidden"
  >
    <div class="flex items-center justify-between px-4 py-3 border-b border-base-300">
      <span class="font-semibold text-sm text-base-content">Notifications</span>
      <button
        type="button"
        class="text-xs text-primary hover:underline"
        (click)="openPreferences()"
      >
        Preferences
      </button>
    </div>

    <div class="relative">
      <div #scrollContainer class="max-h-80 overflow-y-auto">
        <div #topSentinel class="h-px"></div>
        @if (items().length === 0 && hasMore()) {
          <div class="px-4 py-6 text-sm text-base-content/60 text-center">Loading…</div>
        } @else if (items().length === 0) {
          <div class="px-4 py-6 text-sm text-base-content/60 text-center">No recent notifications</div>
        } @else {
          <ul class="menu menu-sm p-0">
            @for (notification of items(); track notification.id) {
              <li #row [attr.data-id]="notification.id">
                <button
                  type="button"
                  class="rounded-none items-start gap-2 py-3 px-4 border-b border-base-200 transition-colors"
                  [class.bg-base-200]="isUnread(notification)"
                  (click)="openNotification(notification)"
                >
                  @if (isUnread(notification)) {
                    <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0"></span>
                  } @else {
                    <span class="mt-1.5 w-1.5 h-1.5 shrink-0"></span>
                  }
                  <div class="flex flex-col gap-1 min-w-0 flex-1 text-left">
                    <div class="flex items-center justify-between gap-2 w-full">
                      <span class="font-medium text-sm truncate text-base-content">
                        {{ notification.title }}
                      </span>
                      <span class="flex items-center gap-1 shrink-0">
                        @if (notification.is_reminder) {
                          <span class="badge badge-outline badge-sm">Reminder</span>
                        }
                        <span [ngClass]="getStatusClass(notification.status)">
                          {{ notification.status }}
                        </span>
                      </span>
                    </div>
                    <span class="text-xs text-base-content/60 line-clamp-2 whitespace-normal">
                      {{ notification.details }}
                    </span>
                    <span class="text-[11px] text-base-content/50">
                      {{ notification.created_at | date: 'MMM d, y · h:mm a' }}
                    </span>
                  </div>
                </button>
              </li>
            }
          </ul>
          @if (loadingMore()) {
            <div class="px-4 py-3 text-xs text-base-content/60 text-center">Loading more…</div>
          }
        }
        <div #bottomSentinel class="h-px"></div>
      </div>
      @if (!atTop()) {
        <div
          class="pointer-events-none absolute inset-x-0 top-0 h-3 bg-gradient-to-b from-base-content/15 to-transparent"
          aria-hidden="true"
        ></div>
      }
      @if (!atEnd()) {
        <div
          class="pointer-events-none absolute inset-x-0 bottom-0 h-3 bg-gradient-to-t from-base-content/15 to-transparent"
          aria-hidden="true"
        ></div>
      }
    </div>

    <div class="border-t border-base-300 px-4 py-2.5 text-center">
      <button
        type="button"
        class="text-sm text-primary hover:underline"
        (click)="openAll()"
      >
        View all notifications
      </button>
    </div>
  </div>
</details>
